﻿import { GroCommon, UploadImageModule } from './common';

$(document).ready(function () {
    var facilityContactPersonPage = new FacilityContactPersonPage();
    facilityContactPersonPage.init();
    $(document).on('change', 'select', function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
            option.attr('selected', true).siblings().removeAttr('selected');
        }
    });
    // enhance table saw to make responsive table
    $(document).trigger('enhance.tablesaw');
});

var FacilityContactPersonFunction =
    FacilityContactPersonFunction ||
    (function () {
        var blockContactPersonUI = function () {
            $('#contactPersonLoader').show();
        };
        var unBlockContactPersonUI = function () {
            $('#contactPersonLoader').hide();
        };
        var contactPersonFillContentToModal = function (
            header,
            content,
            openDialog,
            dialogType,
            callback
        ) {
            var dialogArea = $('#contactPersonDialogArea');
            var iconElement = dialogArea.find('span.popup-type');
            if (dialogType) {
                iconElement.removeClass('hidden');
                iconElement.addClass(GroCommon.getModalIconClass(dialogType));
            } else {
                iconElement.addClass('hidden');
            }

            dialogArea.find('.lm__wide-modal__title').html(header);
            dialogArea.find('p').append(content);
            dialogArea.find('.btn-ok').on('click', function () {
                dialogArea.addClass('hidden');
                if (callback) {
                    callback();
                }
            });
            if (openDialog) {
                dialogArea.removeClass('hidden');
            }
        };
        var contactPersonClearContentToModal = function () {
            var dialogArea = $('#contactPersonDialogArea');
            dialogArea.find('span.alert-icon.popup-type').removeClass('warning success info-icon');
            dialogArea.find('.lm__wide-modal__title').html('');
            dialogArea.find('p').html('');
            dialogArea.find('.btn-ok').unbind('click');
        };
        var contactPersonFillContentToConfirmDialog = function (
            header,
            content,
            okCallback,
            cancelCallBack
        ) {
            var dialogArea = $('#contactPersonConfirmDialog');
            dialogArea.find('.modal-header-title').html(header);
            dialogArea.find('p').append(content);
            dialogArea.find('.btn-cancel').on('click', function () {
                dialogArea.hide();
                if (cancelCallBack) cancelCallBack();
            });
            dialogArea.find('.btn-ok').on('click', function () {
                dialogArea.hide();
                if (okCallback) {
                    okCallback();
                }
            });
            dialogArea.show();
        };
        var contactPersonClearContentToConfirmDialog = function () {
            var dialogArea = $('#contactPersonConfirmDialog');
            dialogArea.find('.lm__wide-modal__title').html('');
            dialogArea.find('p').html('');
            dialogArea.find('.btn-ok').unbind('click');
            dialogArea.find('.btn-cancel').unbind('click');
        };
        var clearContactPersonValidations = function () {
            $('#contactPersonFirstNameError').hide();
            $('#contactPersonLastNameError').hide();
            $('#contactPersonOwnerError').hide();
            $('#contactPersonPrimaryRoleError').hide();
            $('#contactPersonSecondaryRoleError').hide();
            $('#contactPersonPhoneNumberError').hide();
            $('#contactPersonCellNumberError').hide();
            $('#contactPersonEmailError').hide();
            $('#contactPersonCountryError').hide();
            //$("#contactPersonAreaError").hide();
            //$("#contactPersonRegionError").hide();
            $('#contactPersonCityError').hide();
            $('#contactPersonEmploymentTypeError').hide();
            //$("#contactPersonManagerError").hide();
            $('#contactPersonDescriptionError').hide();
        };
        var validateContactPersonSave = function (data) {
            var reEmail =
                /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            var result = true;
            clearContactPersonValidations();
            if (data) {
                var contactPersonFirstName = $.trim(data.ContactPersonFirstName);
                if (contactPersonFirstName == '' || contactPersonFirstName.length > 255) {
                    result = false;
                    $('#contactPersonFirstNameError').show();
                }
                var contactPersonLastName = $.trim(data.ContactPersonLastName);
                if (contactPersonLastName == '' || contactPersonLastName.length > 255) {
                    result = false;
                    $('#contactPersonLastNameError').show();
                }
                var contactPersonOwnerId = $.trim(data.ContactPersonOwnerId);
                if (contactPersonOwnerId == '') {
                    result = false;
                    $('#contactPersonOwnerError').show();
                }
                var primaryRole = $.trim(data.PrimaryRole);
                if (primaryRole == '' || primaryRole.length > 255) {
                    result = false;
                    $('#contactPersonPrimaryRoleError').show();
                }
                var secondaryRole = $.trim(data.SecondaryRole);
                if (secondaryRole != '' && secondaryRole.length > 255) {
                    result = false;
                    $('#contactPersonSecondaryRoleError').show();
                }
                var phoneNumber = $.trim(data.PhoneNumber);
                if (phoneNumber != '' && phoneNumber.length > 20) {
                    result = false;
                    $('#contactPersonPhoneNumberError').show();
                }
                var cellNumber = $.trim(data.CellNumber);
                if (cellNumber != '' && cellNumber.length > 20) {
                    result = false;
                    $('#contactPersonCellNumberError').show();
                }
                var email = $.trim(data.Email);
                if (email !== '' && (email.length > 255 || !reEmail.test(email))) {
                    result = false;
                    $('#contactPersonEmailError').show();
                }
                if ($.trim(data.CountryId) == '') {
                    result = false;
                    $('#contactPersonCountryError').show();
                }
                var city = $.trim(data.City);
                if (city != '' && city.length > 50) {
                    result = false;
                    $('#contactPersonCityError').show();
                }
                var employmentType = $.trim(data.EmploymentType);
                if (employmentType != '' && city.employmentType > 50) {
                    result = false;
                    $('#contactPersonEmploymentTypeError').show();
                }
                if ($.trim(data.Description) != '' && $.trim(data.Description).length > 1200) {
                    result = false;
                    $('#contactPersonDescriptionError').show();
                }
            }

            return result;
        };
        var disableContactPersonButtons = function () {
            //$("#createNewContactPerson").addClass("disabled-btn");
            $('#saveContactPersonBtn').addClass('disabled-btn');
            $('#cancelContactPersonBtn').addClass('disabled-btn');
            $('.js-contact-person-connected-facilities').addClass('disabled-btn');
            $('.js-contact-person-facility-information').addClass('disabled-btn');
        };
        var enableContactPersonButtons = function () {
            //$("#createNewContactPerson").removeClass("disabled-btn");
            $('#saveContactPersonBtn').removeClass('disabled-btn');
            $('#cancelContactPersonBtn').removeClass('disabled-btn');
            $('.js-contact-person-connected-facilities').removeClass('disabled-btn');
            $('.js-contact-person-facility-information').removeClass('disabled-btn');
        };
        return {
            blockContactPersonUI: blockContactPersonUI,
            unBlockContactPersonUI: unBlockContactPersonUI,
            contactPersonFillContentToModal: contactPersonFillContentToModal,
            contactPersonClearContentToModal: contactPersonClearContentToModal,
            contactPersonFillContentToConfirmDialog: contactPersonFillContentToConfirmDialog,
            contactPersonClearContentToConfirmDialog: contactPersonClearContentToConfirmDialog,
            validateContactPersonSave: validateContactPersonSave,
            clearContactPersonValidations: clearContactPersonValidations,
            enableContactPersonButtons: enableContactPersonButtons,
            disableContactPersonButtons: disableContactPersonButtons,
        };
    })();

var FacilityContactPersonPage = function () {
    var dialogType = GroCommon.modalInfoClass;

    var hideContactPersonFacilityInformation = function () {
        $('.js-hide-show-contact-person-facility-information').hide();
    };

    var showContactPersonFacilityInformation = function () {
        $('.js-hide-show-contact-person-facility-information').show();
    };
    var getCurrentlySelectedContactPersonFacilityId = function () {
        return $('#connectedFacilityId').val();
    };
    var getCurrentlySelectedContactPersonFacilityName = function () {
        return $('.contact-person-facility-dropdown :selected').text();
    };
    var showContactPersonFacilityInformationLoader = function () {
        $('#loader-contact-person-facility-information').show();
    };
    var hideContactPersonFacilityInformationLoader = function () {
        $('#loader-contact-person-facility-information').hide();
    };
    var showContactPersonFacilityLoader = function () {
        $('#contact-person-connected-facilities-loader').show();
    };
    var hideContactPersonFacilityLoader = function () {
        $('#contact-person-connected-facilities-loader').hide();
    };
    var showSaveFacilityContactPersonLoader = function () {
        $('#saveFacilityContactPersonLoader').show();
    };
    var hideSaveFacilityContactPersonLoader = function () {
        $('#saveFacilityContactPersonLoader').hide();
    };
    var hideContactPerson = function () {
        $('.js-hide-show-contact-person').hide();
        $('.js-hide-show-contact-persons-by-owner').hide();
    };

    var showContactPerson = function () {
        $('.js-hide-show-contact-person').show();
        $('.js-hide-show-contact-persons-by-owner').hide();
    };
    var showContactPersonsByOwnerList = function () {
        $('.js-hide-show-contact-persons-by-owner').show();
        $('.js-hide-show-contact-person').hide();
    };
    var getCurrentlySelectedContactPersonOwnerId = function () {
        return $('.contact-person-owner-dropdown :selected').val();
    };
    var getCurrentlySelectedContactPersonOwnerName = function () {
        return $('.contact-person-owner-dropdown :selected').text();
    };
    var getCurrentlySelectedContactPersonBusinessAreas = function () {
        return $('input[name="contactPersonBusinessAreas[]"]')
            .filter(function () {
                return this.checked;
            })
            .map(function () {
                return this.value;
            })
            .get()
            .join(',');
    };
    var getConnectedFacilityIds = function () {
        return $('.js-contact-person-connected-facilities')
            .filter(function () {
                return $(this).hasClass('active');
            })
            .map(function () {
                return $(this).data('facilityid');
            })
            .get()
            .join(',');
    };
    var getCurrentlySelectedContactPersonId = function () {
        return $('#SelectedContactPersonId').val();
    };
    var getCurrentlySelectedContactPersonCountryId = function () {
        return $('#ContactPersonCountry :selected').val();
    };
    var getCurrentlySelectedContactPersonAreaId = function () {
        return $('#ContactPersonArea :selected').val();
    };
    var getCurrentlySelectedContactPersonRegionId = function () {
        return $('#ContactPersonRegion :selected').val();
    };
    var getCurrentlySelectedContactPersonManagerId = function () {
        return $('#ContactPersonManager :selected').val();
    };
    var getShowContactPerson = function () {
        return $("input[id='showHideContactPerson']").is(':checked');
    };
    var getIsInternal = function () {
        return $.trim($("input[id='IsInternal']").val());
    };
    var addContactPersonUploadPopupEvent = function () {
        $(document).on('click', function () {
            $('.popup-sub').fadeOut();
        });

        //$(".popup-sub").click(function () { return false; });
        $('.lm__avatar .lm__avatar__upload-btn').click(function () {
            var popupSub = $(this).parent();
            if (popupSub.has('.popup-sub')) {
                popupSub.find('.popup-sub').fadeToggle();
            }
            return false;
        });
    };
    function getContactPersonImageUploadSettings() {
        return {
            fileSelector: '#contact-person-image-avatar__file',
            previewImgSelector: '#contact-person-image-avatar',
            uploadBtnSelector: '#contact-person-image-uploadBtn',
            cancelUploadBtnSelector: '#contact-person-image-cancelUpload',
            linkSelector: '#contact-person-image-link',
            handleUrl: '/api/facility-contact-person/upload-contact-person-image',
            deleteLinkSelector: '#contact-person-image-deleteBtn',
            handleDeleteUrl: '/api/facility-contact-person/delete-contact-person-image',
            isNeedToUpdateHeader: false,
            messages: {
                confirmationDialogSelector: '#dialog-contact-person-image-confirmation',
            },
        };
    }
    var initContactPersonImageUploadEvent = function () {
        addContactPersonUploadPopupEvent();
        //Init for Customer picture
        var facilityContactPersonImageUploadSettings = getContactPersonImageUploadSettings();
        var facilityContactPersonImageUploadModule = UploadImageModule(
            facilityContactPersonImageUploadSettings
        );
        facilityContactPersonImageUploadModule.initDataForRequest([
            { key: 'url', value: $('#contact-person-image-avatar').attr('src') },
        ]);
        facilityContactPersonImageUploadModule.initUploadFile();
        facilityContactPersonImageUploadModule.initDeleteFile();
    };
    var requests = [];
    var fetchContactPersonsByOwner = function () {
        var contactPersonOwnerId = getCurrentlySelectedContactPersonOwnerId();
        var contactPersonOwnerName = getCurrentlySelectedContactPersonOwnerName();
        var isInternal = getIsInternal();
        hideContactPerson();
        FacilityContactPersonFunction.blockContactPersonUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var parameters = {
            contactPersonOwnerId: contactPersonOwnerId,
            contactPersonOwnerName: contactPersonOwnerName,
            isInternal: isInternal,
        };
        $.ajax({
            type: 'Get',
            url: '/api/facility-contact-person/contact-persons-by-owner',
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                var data = response;
                if (data) {
                    if (data.contactPersonsByOwner && data.contactPersonsByOwner.length !== 0) {
                        $('.contactPersonsByOwnerPlaceHolder').html(data.contactPersonsByOwner);
                        /* little fade in effect */
                        $('.contactPersonsByOwnerPlaceHolder').fadeIn('fast');
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching facility contact persons by owner !' +
                        '</br>' +
                        exception
                );
                FacilityContactPersonFunction.contactPersonClearContentToModal();
                FacilityContactPersonFunction.contactPersonFillContentToModal(
                    'Något gick fel',
                    'Det gick inte att hämta kontakt personer',
                    true,
                    dialogType.error
                );
            },
            complete: function (response) {
                $('#createNewContactPerson').removeClass('disabled-btn');
                showContactPersonsByOwnerList();
                FacilityContactPersonFunction.unBlockContactPersonUI();
            },
        });
    };
    var reloadContactPersonsByOwner = function () {
        var contactPersonOwnerId = getCurrentlySelectedContactPersonOwnerId();
        if ($.trim(contactPersonOwnerId) != '') {
            $('#createNewContactPerson').removeClass('disabled-btn');
            fetchContactPersonsByOwner();
        } else {
            $('#createNewContactPerson').addClass('disabled-btn');
            hideContactPerson();
        }
    };
    var getContactPersonForEditing = function (contactPersonId) {
        var contactPersonOwnerId = getCurrentlySelectedContactPersonOwnerId();
        var contactPersonOwnerName = getCurrentlySelectedContactPersonOwnerName();
        var isInternal = getIsInternal();
        hideContactPerson();
        FacilityContactPersonFunction.blockContactPersonUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var parameters = {
            contactPersonId: contactPersonId,
            contactPersonOwnerId: contactPersonOwnerId,
            contactPersonOwnerName: contactPersonOwnerName,
            isInternal: isInternal,
        };
        $.ajax({
            type: 'Get',
            url: '/api/facility-contact-person/edit-contact-person',
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                if (data) {
                    if (
                        data.contactPersonInformation &&
                        data.contactPersonInformation.length !== 0
                    ) {
                        $('.contactPersonPlaceHolder').html(data.contactPersonInformation);
                        /* little fade in effect */
                        $('.contactPersonPlaceHolder').fadeIn('fast');
                    }
                    initContactPersonImageUploadEvent();
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching Contact Person for editing!' +
                        '</br>' +
                        exception
                );
                FacilityContactPersonFunction.contactPersonClearContentToModal();
                FacilityContactPersonFunction.contactPersonFillContentToModal(
                    'Något gick fel',
                    'Det gick inte att hämta kontakt personer',
                    true,
                    dialogType.error,
                    reloadContactPersonsByOwner
                );
            },
            complete: function (response) {
                showContactPerson();
                FacilityContactPersonFunction.unBlockContactPersonUI();
            },
        });
    };
    var fetchContactPersonAreas = function () {
        var parentCategoryId = getCurrentlySelectedContactPersonCountryId();
        FacilityContactPersonFunction.blockContactPersonUI();
        $.each(requests, function (index, request) {
            request.abort();
        });

        $('.contact-person-area-dropdown').html('');
        $('.contact-person-region-dropdown').html('');
        $('.contactPersonAreaSelection').addClass('hidden');
        $('.contactPersonRegionSelection').addClass('hidden');

        requests = [];
        var parameters = {
            parentCategoryId: parentCategoryId,
        };
        $.ajax({
            type: 'Get',
            url: '/api/facility-contact-person/contact-person-sub-categories-by-parent-category',
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                if (response) {
                    var subCategories =
                        typeof response.subCategories == 'string'
                            ? JSON.parse(response.subCategories)
                            : response.subCategories;
                    $.each(subCategories, function (index, subCategory) {
                        $('.contact-person-area-dropdown').append(
                            "<option value='" +
                                subCategory.Value +
                                "'>" +
                                subCategory.Text +
                                '</option>'
                        );
                    });
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching geografiskt områder!' +
                        '</br>' +
                        exception
                );
                FacilityContactPersonFunction.contactPersonClearContentToModal();
                FacilityContactPersonFunction.contactPersonFillContentToModal(
                    'Något gick fel',
                    'Det gick inte att hämta geografiskt områder',
                    true,
                    dialogType.error,
                    reloadContactPersonsByOwner
                );
            },
            complete: function (response) {
                FacilityContactPersonFunction.unBlockContactPersonUI();
                $('.contactPersonAreaSelection').removeClass('hidden');
            },
        });
    };
    var fetchContactPersonRegions = function () {
        var parentCategoryId = getCurrentlySelectedContactPersonAreaId();
        FacilityContactPersonFunction.blockContactPersonUI();
        $.each(requests, function (index, request) {
            request.abort();
        });

        $('.contact-person-region-dropdown').html('');
        $('.contactPersonRegionSelection').addClass('hidden');

        requests = [];
        var parameters = {
            parentCategoryId: parentCategoryId,
        };
        $.ajax({
            type: 'Get',
            url: '/api/facility-contact-person/contact-person-sub-categories-by-parent-category',
            async: true,
            cache: false,
            data: parameters,
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (response) {
                if (response) {
                    var subCategories =
                        typeof response.subCategories == 'string'
                            ? JSON.parse(response.subCategories)
                            : response.subCategories;
                    $.each(subCategories, function (index, subCategory) {
                        $('.contact-person-region-dropdown').append(
                            "<option value='" +
                                subCategory.Value +
                                "'>" +
                                subCategory.Text +
                                '</option>'
                        );
                    });
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching regions!' +
                        '</br>' +
                        exception
                );
                FacilityContactPersonFunction.contactPersonClearContentToModal();
                FacilityContactPersonFunction.contactPersonFillContentToModal(
                    'Något gick fel',
                    'Det gick inte att hämta regions',
                    true,
                    dialogType.error,
                    reloadContactPersonsByOwner
                );
            },
            complete: function (response) {
                FacilityContactPersonFunction.unBlockContactPersonUI();
                $('.contactPersonRegionSelection').removeClass('hidden');
            },
        });
    };

    var getContactPersonInformationPayload = function () {
        var payload = {
            ContactPersonId: getCurrentlySelectedContactPersonId(),
            ContactPersonFirstName: $.trim($("input[id='ContactPersonFirstName']").val()),
            ContactPersonLastName: $.trim($("input[id='ContactPersonLastName']").val()),
            ContactPersonOwnerId: getCurrentlySelectedContactPersonOwnerId(),
            ContactPersonOwnerName: getCurrentlySelectedContactPersonOwnerName(),
            ContactPersonBusinessAreas: getCurrentlySelectedContactPersonBusinessAreas(),
            PrimaryRole: $.trim($("input[id='ContactPersonPrimaryRole']").val()),
            SecondaryRole: $.trim($("input[id='ContactPersonSecondaryRole']").val()),
            PhoneNumber: $.trim($("input[id='ContactPersonPhoneNumber']").val()),
            CellNumber: $.trim($("input[id='ContactPersonCellNumber']").val()),
            Email: $.trim($("input[id='ContactPersonEmail']").val()),
            EmploymentType: $.trim($("input[id='ContactPersonEmploymentType']").val()),
            ContactPersonInfoSource: $.trim($("input[id='FacilityContactPersonInfoSource']").val()),
            ShowContactPersonInfo: getShowContactPerson(),
            Description: $.trim($("textArea[id='ContactPersonDescription']").val()),
            ContactPersonImageUrl: $('#contact-person-image-avatar').attr('src'),
            City: $.trim($("input[id='ContactPersonCity']").val()),
            CountryId: $.trim(getCurrentlySelectedContactPersonCountryId()),
            AreaId: $.trim(getCurrentlySelectedContactPersonAreaId()),
            RegionId: $.trim(getCurrentlySelectedContactPersonRegionId()),
            ManagerId: $.trim(getCurrentlySelectedContactPersonManagerId()),
            Country: '',
            Area: '',
            Region: '',
            ManagerName: '',
            ConnectedFacilityIds: getConnectedFacilityIds(),
        };
        return payload;
    };
    var validateSaveContactPersonInformation = function (data) {
        var arr = [];
        var reEmail =
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

        if ($.trim(data.ContactPersonFirstName) == '') {
            arr[arr.length] = '<li>Förnamn saknar värde.</li>';
        } else if ($.trim(data.ContactPersonFirstName).length > 255) {
            arr[arr.length] = '<li>Förnamn kan vara max 255 tecken.</li>';
        }
        if ($.trim(data.ContactPersonLastName) == '') {
            arr[arr.length] = '<li>Efternamn saknar värde.</li>';
        } else if ($.trim(data.ContactPersonLastName).length > 255) {
            arr[arr.length] = '<li>Efternamn kan vara max 255 tecken.</li>';
        }
        if ($.trim(data.ContactPersonOwnerId) == '') {
            arr[arr.length] = '<li>Företag saknar värde.</li>';
        }
        if ($.trim(data.ContactPersonBusinessAreas) == '') {
            arr[arr.length] = '<li>Verksamhetsområde saknar värde.</li>';
        }
        if ($.trim(data.PrimaryRole) == '') {
            arr[arr.length] = '<li>Primärt title saknar värde.</li>';
        } else if ($.trim(data.PrimaryRole).length > 255) {
            arr[arr.length] = '<li>Primärt title kan vara max 255 tecken.</li>';
        }
        if ($.trim(data.SecondaryRole) != '' && $.trim(data.SecondaryRole).length > 255) {
            arr[arr.length] = '<li>Sekundärt title kan vara max 255 tecken.</li>';
        }
        if ($.trim(data.PhoneNumber) != '' && $.trim(data.PhoneNumber).length > 20) {
            arr[arr.length] = '<li>Telefonnummer kan vara max 20 tecken.</li>';
        }
        if ($.trim(data.CellNumber) != '' && $.trim(data.CellNumber).length > 20) {
            arr[arr.length] = '<li>Mobilnummer kan vara max 20 tecken.</li>';
        }
        var email = $.trim(data.Email);
        if (email !== '' && (email.length > 255 || !reEmail.test(email))) {
            arr[arr.length] = '<li>Ange ett giltigt e-post adress.</li>';
        }
        if ($.trim(data.CountryId) == '') {
            arr[arr.length] = '<li>Land saknar värde.</li>';
        }
        if ($.trim(data.City) != '' && $.trim(data.City).length > 50) {
            arr[arr.length] = '<li>Kontor kan vara max 50 tecken.</li>';
        }
        if ($.trim(data.EmploymentType) != '' && $.trim(data.EmploymentType).length > 50) {
            arr[arr.length] = '<li>Anställningstyp kan vara max 50 tecken.</li>';
        }
        if ($.trim(data.Description) != '' && $.trim(data.Description).length > 1200) {
            arr[arr.length] = '<li>Beskrivning/Resume kan vara max 1200 tecken.</li>';
        }
        return arr;
    };
    var saveContactPersonInformation = function () {
        $.each(requests, function (index, request) {
            request.abort();
        });

        requests = [];

        var contactPersonInformationPayload = getContactPersonInformationPayload();

        if (
            FacilityContactPersonFunction.validateContactPersonSave(contactPersonInformationPayload)
        ) {
            showSaveFacilityContactPersonLoader();
            FacilityContactPersonFunction.disableContactPersonButtons();
            var isInternal = getIsInternal();
            $.ajax({
                type: 'POST',
                url: '/api/facility-contact-person/save-contact-person',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                async: true,
                cache: false,
                data: JSON.stringify({
                    contactPersonInformation: contactPersonInformationPayload,
                    isInternal: isInternal,
                }),
                success: function (response) {
                    FacilityContactPersonFunction.enableContactPersonButtons();
                    FacilityContactPersonFunction.contactPersonClearContentToModal();
                    if (response) {
                        FacilityContactPersonFunction.contactPersonFillContentToModal(
                            'Kontaktpersoner sparad',
                            '',
                            true,
                            dialogType.error,
                            reloadContactPersonsByOwner
                        );
                    } else {
                        FacilityContactPersonFunction.contactPersonFillContentToModal(
                            'Fel att spara kontakt person',
                            '',
                            true,
                            dialogType.error
                        );
                    }
                },
                error: function () {
                    FacilityContactPersonFunction.enableContactPersonButtons();
                    FacilityContactPersonFunction.contactPersonClearContentToModal();
                    FacilityContactPersonFunction.contactPersonFillContentToModal(
                        'Fel att spara kontakt person',
                        '',
                        true,
                        dialogType.error
                    );
                },
                complete: function (response) {
                    FacilityContactPersonFunction.enableContactPersonButtons();
                    hideSaveFacilityContactPersonLoader();
                },
            });
        } else {
            var errors = validateSaveContactPersonInformation(contactPersonInformationPayload);
            if (errors.length > 0) {
                FacilityContactPersonFunction.contactPersonClearContentToModal();
                var errorContent = $('<p></p>').append('<ul>' + errors.join('') + '</ul>');
                FacilityContactPersonFunction.contactPersonFillContentToModal(
                    '',
                    errorContent,
                    true,
                    dialogType.error
                );
            }
        }
    };
    var createNewContactPersonInformation = function () {
        var isInternal = getIsInternal();
        var contactPersonOwnerId = getCurrentlySelectedContactPersonOwnerId();
        var contactPersonOwnerName = getCurrentlySelectedContactPersonOwnerName();

        hideContactPerson();
        FacilityContactPersonFunction.blockContactPersonUI();
        $('#createNewContactPerson').addClass('disabled-btn');

        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        //$("#facility-contact-person-info-option > select > option")[0].selected = true;
        //$('.facility-contact-person-info-selection-controls').addClass('disabled');

        $.ajax({
            type: 'Post',
            url: '/api/facility-contact-person/create-new-contact-person',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            async: true,
            cache: false,
            data: JSON.stringify({
                contactPersonOwnerId: contactPersonOwnerId,
                contactPersonOwnerName: contactPersonOwnerName,
                isInternal: isInternal,
            }),
            success: function (data) {
                if (data) {
                    if (
                        data.contactPersonInformation &&
                        data.contactPersonInformation.length !== 0
                    ) {
                        $('.contactPersonPlaceHolder').html(data.contactPersonInformation);
                        /* little fade in effect */
                        $('.contactPersonPlaceHolder').fadeIn('fast');
                    }
                    initContactPersonImageUploadEvent();
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching Contact Person for editing!' +
                        '</br>' +
                        exception
                );
                FacilityContactPersonFunction.contactPersonClearContentToModal();
                FacilityContactPersonFunction.contactPersonFillContentToModal(
                    'Det gick inte att skapa ny kontakt personer',
                    '',
                    true,
                    dialogType.error
                );
            },
            complete: function (response) {
                showContactPerson();
                FacilityContactPersonFunction.unBlockContactPersonUI();
            },
        });
    };
    var deleteContactPersonInformation = function (selectedContactPersonId) {
        FacilityContactPersonFunction.disableContactPersonButtons();
        FacilityContactPersonFunction.blockContactPersonUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        $.ajax({
            type: 'POST',
            url: '/api/facility-contact-person/delete-contact-person',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            async: true,
            cache: false,
            data: JSON.stringify({
                contactPersonOwnerId: getCurrentlySelectedContactPersonOwnerId(),
                contactPersonId: selectedContactPersonId,
            }),
            success: function (response) {
                FacilityContactPersonFunction.contactPersonClearContentToModal();
                if (response) {
                    FacilityContactPersonFunction.contactPersonFillContentToModal(
                        'Kontakt personer har tagits bort',
                        '',
                        true,
                        dialogType.error,
                        reloadContactPersonsByOwner
                    );
                } else {
                    FacilityContactPersonFunction.contactPersonFillContentToModal(
                        'Fel uppstod när kontaktpersonen skulle tas bort.',
                        '',
                        true,
                        dialogType.error
                    );
                }
            },
            error: function () {
                FacilityContactPersonFunction.contactPersonClearContentToModal();
                FacilityContactPersonFunction.contactPersonFillContentToModal(
                    'Det gick inte att tabort kontakt personer',
                    '',
                    true,
                    dialogType.error
                );
            },
            complete: function (response) {
                FacilityContactPersonFunction.enableContactPersonButtons();
                FacilityContactPersonFunction.unBlockContactPersonUI();
            },
        });
    };
    var fetchContactPersonFacilityInformation = function () {
        var selectedFacilityId = getCurrentlySelectedContactPersonFacilityId();
        var contactPersonId = getCurrentlySelectedContactPersonId();
        var isInternal = getIsInternal();
        hideContactPersonFacilityInformation();
        showContactPersonFacilityInformationLoader();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var contactPersonFacilityInformationUrl =
            '/api/facility-contact-person/contact-person-facility-information';
        var contactPersonFacilityConnectionUrl =
            '/api/facility-contact-person/contact-person-facility-connection';

        var contactPersonFacilityInformationDeferred = $.ajax({
            type: 'Get',
            url: contactPersonFacilityInformationUrl,
            async: true,
            cache: false,
            data: { facilityId: selectedFacilityId, isInternal: isInternal },
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                if (data) {
                    $('.js-contact-person-facility-information')[0].setAttribute(
                        'facilityid',
                        selectedFacilityId
                    );
                    if (
                        data.contactPersonFacilityInformation &&
                        data.contactPersonFacilityInformation.length !== 0
                    ) {
                        $('.contactPersonFacilityInformationPlaceHolder').html(
                            data.contactPersonFacilityInformation
                        );
                        $('.selected-facility-name').html(
                            getCurrentlySelectedContactPersonFacilityName()
                        );
                        /* little fade in effect */
                        $('.contactPersonFacilityInformationPlaceHolder').fadeIn('fast');
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching FacilityInformation!' +
                        '</br>' +
                        exception.Message
                );
                $('.contactPersonFacilityInformationPlaceHolder').html(
                    '<h2>Failed to fetch facility information</h2>'
                );
            },
        });
        var contactPersonFacilityConnectionDeferred = $.ajax({
            type: 'Get',
            url: contactPersonFacilityConnectionUrl,
            async: true,
            cache: false,
            data: { contactPersonId: contactPersonId, facilityId: selectedFacilityId },
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                if (data) {
                    var isFacilityConnected = data.isFacilityConnected;
                    if (isFacilityConnected) {
                        $('.js-contact-person-facility-information').addClass('active');
                    } else {
                        $('.js-contact-person-facility-information').removeClass('active');
                    }
                    $('.js-contact-person-facility-information')[0].setAttribute(
                        'facilityid',
                        selectedFacilityId
                    );
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for fetching FacilityConnection!' +
                        '</br>' +
                        exception.Message
                );
            },
        });
        requests.push(contactPersonFacilityInformationDeferred);
        requests.push(contactPersonFacilityConnectionDeferred);
        $.when.apply($, requests).then(function () {
            hideContactPersonFacilityInformationLoader();
            showContactPersonFacilityInformation();
        });
    };
    var connectFacilityToContactPerson = function (facilityId, isNewConnection) {
        var contactPersonId = getCurrentlySelectedContactPersonId();
        var isInternal = getIsInternal();
        showContactPersonFacilityLoader();
        $.each(requests, function (index, request) {
            request.abort();
        });
        requests = [];
        var tableResult = $('#contact-person-connected-facilities');
        $.ajax({
            url: '/api/facility-contact-person/connect-facility-to-contact-person',
            type: 'POST',
            async: true,
            cache: false,
            data: JSON.stringify({
                contactPersonId: contactPersonId,
                facilityId: facilityId,
                isNewConnection: isNewConnection,
                isInternal: isInternal,
            }),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) {
                hideContactPersonFacilityLoader();
                if (data) {
                    if (
                        data.contactPersonConnectedFacilities &&
                        data.contactPersonConnectedFacilities.length !== 0
                    ) {
                        tableResult.html(data.contactPersonConnectedFacilities);
                        /* little fade in effect */
                        tableResult.fadeIn('fast');
                        if (
                            !$('.js-hide-show-contact-person-facility-information').hasClass(
                                'hidden'
                            ) &&
                            $('.js-contact-person-facility-information')[0].getAttribute(
                                'facilityid'
                            ) == facilityId
                        ) {
                            if (isNewConnection) {
                                if (
                                    !$('.js-contact-person-facility-information').hasClass('active')
                                )
                                    $('.js-contact-person-facility-information').addClass('active');
                            } else if (
                                $('.js-contact-person-facility-information').hasClass('active')
                            ) {
                                $('.js-contact-person-facility-information').removeClass('active');
                            }
                        }
                    }
                }
            },
            error: function (jqXHR, status, exception) {
                console.error(
                    'Something went wrong with the AJAX request for connecting facility to contact person!' +
                        '</br>' +
                        exception.Message
                );
                tableResult.empty();
                hideContactPersonFacilityLoader();
            },
        });
        return false;
    };
    var fetchContactPersonsByOwnerEvent = function () {
        $('.contact-person-owner-dropdown').on('change', function () {
            FacilityContactPersonFunction.clearContactPersonValidations();
            FacilityContactPersonFunction.contactPersonClearContentToModal();
            var selectedContactPersonOwner = getCurrentlySelectedContactPersonOwnerId();
            $('#createNewContactPerson').addClass('disabled-btn');
            if ($.trim(selectedContactPersonOwner) != '') {
                fetchContactPersonsByOwner();
            } else {
                hideContactPerson();
            }
        });
    };
    var getContactPersonForEditingEvent = function () {
        $(document).on('click', '.contact-person', function (event) {
            FacilityContactPersonFunction.clearContactPersonValidations();
            FacilityContactPersonFunction.contactPersonClearContentToModal();
            var contactPersonId = $(this).data('contactpersonid');
            $('#createNewContactPerson').addClass('disabled-btn');
            getContactPersonForEditing(contactPersonId);
        });
    };
    var saveContactPersonEvent = function () {
        $(document).on('click', '#saveContactPersonBtn', function (event) {
            saveContactPersonInformation();
        });
    };
    var createNewContactPersonEvent = function () {
        $(document).on('click', '#createNewContactPerson', function (event) {
            createNewContactPersonInformation();
        });
    };
    var cancelContactPersonEvent = function () {
        $(document).on('click', '#cancelContactPersonBtn', function (event) {
            var content = $('<p></p>').append('Alla förändringar kommer att förloras!');
            FacilityContactPersonFunction.contactPersonClearContentToConfirmDialog();
            FacilityContactPersonFunction.contactPersonFillContentToConfirmDialog(
                'Vill du verkligen avbryt ändringar?',
                content,
                reloadContactPersonsByOwner
            );
        });
    };
    var deleteContactPersonEvent = function () {
        $(document).on('click', '.contact-person-deleteBtn', function (event) {
            var selectedContactPersonName = $(this).data('contactpersonname');
            var selectedContactPersonId = $(this).data('contactpersonid');
            var content = $('<p></p>').append(
                'Vill du verkligen ta bort kontakt person <strong>' +
                    selectedContactPersonName +
                    '</strong>?'
            );
            FacilityContactPersonFunction.contactPersonClearContentToConfirmDialog();
            FacilityContactPersonFunction.contactPersonFillContentToConfirmDialog(
                '',
                content,
                deleteContactPersonInformation.bind(null, selectedContactPersonId)
            );
        });
    };
    var selectAllContactPersonBusinessAreasEvent = function () {
        $(document).on('change', '.js-select-all-contact-person-business-areas', function (event) {
            var isChecked = $(this).is(':checked');
            $('input[name="contactPersonBusinessAreas[]"]').prop('checked', isChecked);
        });
    };
    var selectAllFacilitiesEvent = function () {
        $(document).on('change', '.js-select-all-contact-person-facilities', function (event) {
            var isChecked = $(this).is(':checked');
            $('input[name="contactPersonFacilities[]"]').prop('checked', isChecked);
        });
    };
    var fetchContactPersonAreasEvent = function () {
        $(document).on('change', '.contact-person-country-dropdown', function (event, data) {
            FacilityContactPersonFunction.clearContactPersonValidations();
            FacilityContactPersonFunction.contactPersonClearContentToModal();
            fetchContactPersonAreas();
        });
    };
    var fetchContactPersonRegionsEvent = function () {
        $(document).on('change', '.contact-person-area-dropdown', function (event, data) {
            FacilityContactPersonFunction.clearContactPersonValidations();
            FacilityContactPersonFunction.contactPersonClearContentToModal();
            fetchContactPersonRegions();
        });
    };
    var fetchContactPersonFacilityInformationEvent = function () {
        $(document).on('change', '.contact-person-facility-dropdown', function (event, data) {
            fetchContactPersonFacilityInformation();
        });
    };
    var connectFacilityToContactPersonEvent = function (obj, facilityId) {
        if ($(obj).hasClass('active')) {
            connectFacilityToContactPerson(facilityId, false);
            $(obj).toggleClass('active');
        } else {
            connectFacilityToContactPerson(facilityId, true);
            $(obj).toggleClass('active');
        }
    };
    var contactPersonFacilityInformationClickEvent = function () {
        $(document).on('click', '.js-contact-person-facility-information', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var facilityId = $(this)[0].getAttribute('facilityid');
            connectFacilityToContactPersonEvent($(this), facilityId);
        });
    };
    var contactPersonConnectedFacilitiesClickEvent = function () {
        $(document).on('click', '.js-contact-person-connected-facilities', function (e) {
            e.stopPropagation();
            e.preventDefault();
            var facilityId = $(this).data('facilityid');
            connectFacilityToContactPersonEvent($(this), facilityId);
        });
    };

    var init = function () {
        fetchContactPersonsByOwnerEvent();
        getContactPersonForEditingEvent();
        createNewContactPersonEvent();
        saveContactPersonEvent();
        deleteContactPersonEvent();
        cancelContactPersonEvent();
        selectAllContactPersonBusinessAreasEvent();
        selectAllFacilitiesEvent();
        fetchContactPersonAreasEvent();
        fetchContactPersonRegionsEvent();
        fetchContactPersonFacilityInformationEvent();
        contactPersonConnectedFacilitiesClickEvent();
        contactPersonFacilityInformationClickEvent();
    };
    return {
        init: init,
    };
};
